/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */
/*
 * --------------------------------------------------------------------------------
 * This file contains the enumeration used to signify the current state of a
 * request.
 * --------------------------------------------------------------------------------
 */
/*
 * --------------------------------------------------------------------------------
 * Enumerations
 * --------------------------------------------------------------------------------
 */
/**
 * This enumeration signifies the current state of a request.
 */
var RequestState;
(function (RequestState) {
    /**
     * The request has not yet been sent.
     */
    RequestState[RequestState["None"] = 1] = "None";
    /**
     * The request is being carried out.
     */
    RequestState[RequestState["Pending"] = 2] = "Pending";
    /**
     * The request was cancelled.
     */
    RequestState[RequestState["Cancel"] = 3] = "Cancel";
    /**
     * The request failed.
     */
    RequestState[RequestState["Failure"] = 4] = "Failure";
    /**
     * The request was successful.
     */
    RequestState[RequestState["Success"] = 5] = "Success";
})(RequestState || (RequestState = {}));
/*
 * --------------------------------------------------------------------------------
 * Default Export
 * --------------------------------------------------------------------------------
 */
export default RequestState;
//# sourceMappingURL=RequestState.js.map